import config from 'config'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { checkNested } from 'srcReact/helpers/validator'
import { SideBarMenu } from 'srcReact/components/common2/Navigation/SideBarMenu'
import ScrollToTop from 'srcReact/components/common/ScrollToTop'
import styles from './styles.module.scss'
import LinkButton from 'srcReact/components/common2/LinkButton'
import Icon from 'srcReact/components/icons/Icon'
import MobileModal from 'srcReact/components/common2/MobileModal'
import NotificationList from 'srcReact/OrganizationPage/NotificationList'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { messengerActions } from 'srcReact/MessengerPage'
import { redirectToPage } from 'srcReact/helpers/history'
import { useDispatch, useSelector } from 'react-redux'

function MobileHeader({ currentOrganization, loggedInUser, isNative, messenger, notifications }) {
  const { t } = useTranslation()
  const headerRef = useRef(null)
  const dispatch = useDispatch()
  const {
    organizationSettings: {
      organizationInfo: { info }
    }
  } = useSelector((state) => state)
  const [menuOpen, setMenuOpen] = useState(false)
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const handleStateChange = (state) => {
    setMenuOpen(state.isOpen)
  }

  const openNotificationModal = () => {
    setIsNotificationModalOpen(true)
  }

  const closeNotificationModal = () => {
    setIsNotificationModalOpen(false)
  }

  const handleLink = (pagePath) => {
    redirectToPage(`/${pagePath}`, isNative)
  }

  const handleMessenger = () => {
    dispatch(messengerActions.showSidebar(true))
    dispatch(messengerActions.showMainContent(false))
    redirectToPage(`/0/messenger`)
  }

  return (
    <React.Fragment>
      {!isNative && (
        <header
          ref={headerRef}
          className={`${styles.siteHeaderMobile} ${isNative ? styles.isNative : styles.isNotNative}`}>
          <SideBarMenu
            isOpen={menuOpen}
            onStateChange={(state) => handleStateChange(state)}
            clickAction={() => toggleMenu()}
            handleLink={handleLink}
            notificationCount={notifications?.unread_count}
          />
          <nav className={styles.bannerMobile}>
            <div className={styles.left}>
              <a className={styles.burger} onClick={() => toggleMenu()}>
                <Icon name='menu24' size='large24' />
              </a>
              {loggedInUser && (
                <a
                  aria-label={t('globalSearch.searchPlaceholder')}
                  className={styles.search}
                  href={config.webUrl + '/0/search'}>
                  <Icon name='search24' size='large24' />
                </a>
              )}
            </div>
            <a className={styles.center} href={`/0/${appConstantSettings.DEFAULT_HOMEPAGE}`}>
              {currentOrganization && checkNested(currentOrganization, 'info', 'picture') ? (
                <img
                  src={info?.picture || currentOrganization.info.picture}
                  height='36'
                  className={styles.orgLogo}
                  alt={currentOrganization.info.name}
                />
              ) : (
                <img
                  src={config.assetUrl + '/images/logo-mixr.png'}
                  height='36'
                  className={(!loggedInUser ? styles.ml3 + ' ' : '') + styles.orgLogo}
                  alt={t('global.home')}
                />
              )}
            </a>
            {loggedInUser ? (
              <div className={styles.right}>
                <button
                  id='notification_icon_button'
                  className={styles.notification}
                  onClick={openNotificationModal}
                  aria-label={`${t('formlabel.openNotifications')} ${
                    notifications?.unread_count > 0
                      ? t('formlabel.notificationCount', { count: notifications?.unread_count })
                      : ''
                  }`}>
                  <Icon name='bell' size='larger' />
                  {/* {notifications && notifications.new_notification && <span className={styles.badge} />} */}
                  {notifications && notifications.unread_count > 0 && notifications.new_notification && (
                    <span className={styles.badge}>
                      {notifications.unread_count > 99 ? '99+' : notifications.unread_count}
                    </span>
                  )}
                </button>
                <button
                  id='onboarding_messenger'
                  className={`${styles.message} ${messenger && messenger.unread_count > 0 && styles.unreadCount}`}
                  onClick={handleMessenger}
                  aria-label={`${t('formlabel.gotoMessenger')} ${
                    messenger?.unread_count > 0
                      ? t('formlabel.messengerNotificationCount', { count: messenger?.unread_count })
                      : ''
                  }`}>
                  <Icon name='chat24' size='large24' />
                  {messenger && messenger.unread_count > 0 && (
                    <span className={styles.badge}>{messenger.unread_count > 99 ? '99+' : messenger.unread_count}</span>
                  )}
                  <Icon name='arrow-right' size='large24' />
                </button>
              </div>
            ) : (
              <div className={styles.right}>
                <LinkButton href={config.webUrl + '/auth'} style='primary' size='medium' text={t('global.login')} />
              </div>
            )}
          </nav>
        </header>
      )}
      {isNotificationModalOpen && (
        <NotificationList isOpen={isNotificationModalOpen} closeModal={closeNotificationModal} />
      )}
      {!loggedInUser && <ScrollToTop />}
    </React.Fragment>
  )
}

export default MobileHeader
